import React from 'react'
import ChartFlexSection from '@components/chart/ChartFlexSection'
import { IResponseOptAgencyNewAndOldStats } from '@interfaces/api/IDashboard'
import TextChartTitle from '@components/text/TextChartTitle'
import CardDashboardStatGroup from '@components/card/CardDashboardStatGroup'
import { Num, ThY } from '@utils/utils'
import Stat from '@components/chart/Stat'
import Chart from 'react-google-charts'
import { ColumnChartOptions } from '@components/chart/setting'

const AgencyNewAndOldStats = ({ title, data }: { title: string; data: IResponseOptAgencyNewAndOldStats }) => {
  const options = ColumnChartOptions('มูลค่าโครงการ', 'ปีงบประมาณ')
  const chartData = [
    [
      'ปีงบประมาณ',
      'ลูกค้าเก่า',
      { type: 'string', role: 'annotation' },
      { role: 'tooltip', type: 'string', p: { html: true } },
      'ลูกค้าใหม่',
      { type: 'string', role: 'annotation' },
      { role: 'tooltip', type: 'string', p: { html: true } },
    ],
    ...data.map((item) => {
      const row: (string | number | null)[] = [String(ThY(item.budget_year))]
      const factors: Partial<Record<keyof IResponseOptAgencyNewAndOldStats[number], string>> = {
        total_old_agencies: 'ลูกค้าเก่า',
        total_new_agencies: 'ลูกค้าใหม่',
      }
      ;(Object.keys(factors) as (keyof IResponseOptAgencyNewAndOldStats[number])[]).forEach((factor) => {
        row.push(parseFloat(String(item[factor])))
        row.push(Num(item[factor]))
        row.push(`<div style="padding:8px; width: 280px">
        <strong>ปีงบประมาณ ${ThY(item.budget_year)}</strong><br/>
        <strong>${factors[factor]}</strong><br/>
        จำนวนลูกค้า : ${Num(item[factor])} ลูกค้า<br/>
      </div>`)
      })

      return row
    }),
  ]

  return (
    <ChartFlexSection>
      <TextChartTitle>{title}</TextChartTitle>
      {/*{data.length > 1 && (*/}
      {/*  <CardDashboardStatGroup>*/}
      {/*    <Stat w={150} label={'จำนวนลูกค้าทั้งหมด'} value={Num(_.sum(data.map((r) => r.total_agencies)))} unit="โครงการ" />*/}
      {/*  </CardDashboardStatGroup>*/}
      {/*)}*/}
      {data.map((result, index) => {
        return (
          <CardDashboardStatGroup key={result.budget_year}>
            <Stat w={150} label={index > 0 ? '' : 'ปีงบประมาณ'} value={ThY(result.budget_year)} />
            <Stat
              w={200}
              label={index > 0 ? '' : 'จำนวนลูกค้าทั้งหมด'}
              value={Num(result.total_agencies)}
              unit="หน่วยงาน"
              diff={result.total_agencies_diff}
            />
            <Stat
              w={320}
              label={index > 0 ? '' : 'จำนวนลูกค้าเก่า'}
              value={Num(result.total_old_agencies) + ` (${result.percentage_old_agencies}%)`}
              unit="หน่วยงาน"
              diff={result.total_old_agencies_diff}
            />
            <Stat
              w={320}
              label={index > 0 ? '' : 'จำนวนลูกค้าใหม่'}
              value={Num(result.total_new_agencies) + ` (${result.percentage_new_agencies}%)`}
              unit="หน่วยงาน"
              diff={result.total_new_agencies_diff}
            />
          </CardDashboardStatGroup>
        )
      })}
      <Chart width={'100%'} height={'500px'} chartType="ColumnChart" loader={<div>Loading Chart</div>} data={chartData} options={options} />
    </ChartFlexSection>
  )
}

export default AgencyNewAndOldStats
